var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnewProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.907,
    height: 100.587,
    viewBox: "0 0 104.907 100.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6fbb2e;}.b{fill:#addb31;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.244,81.571,0,49.437,19.7,30.389l13.546,13.1L78.221,0l19.7,19.043Zm0,0",
    transform: "translate(0 -0.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.233,171.314,32.992,139.176l19.695-19.043,13.546,13.1,44.98-43.485,19.695,19.044Zm0,0",
    transform: "translate(-26 -70.727)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnewProduct);
export default __webpack_public_path__ + "static/media/knew_product.07abc007a5281e99518e3c9f50965505.svg";
export { ForwardRef as ReactComponent };